import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import styles from '../../pages/UpgradePage.module.css';

const NAMES = { pro: 'Pro', teams: 'Teams' };

export function waitlistJoinedCopy(plan, { already = false } = {}) {
  const name = NAMES[plan] || 'this plan';
  const lead = already ? `You're already on the ${name} waitlist.` : `You're on the ${name} waitlist.`;
  return `${lead} We'll email you when ${name} becomes available.`;
}

export default function PlanWaitlistButton({ plan, joined = false }) {
  const [phase, setPhase] = useState(joined ? 'already' : 'idle');
  const [error, setError] = useState('');
  const name = NAMES[plan] || 'plan';

  useEffect(() => {
    if (joined) {
      setPhase((current) => (current === 'idle' ? 'already' : current));
    }
  }, [joined]);

  const join = async () => {
    setPhase('loading');
    setError('');
    try {
      const res = await api.post('/api/plan-waitlist', { plan });
      setPhase(res.data?.status === 'already_joined' ? 'already' : 'joined');
    } catch (err) {
      setPhase('idle');
      setError(err.response?.data?.message || "We couldn't save that. Please try again.");
    }
  };

  if (phase === 'joined' || phase === 'already') {
    return (
      <p className={styles.waitlistOk} role="status">
        {waitlistJoinedCopy(plan, { already: phase === 'already' })}
      </p>
    );
  }

  return (
    <>
      <button
        type="button"
        className={styles.cta}
        onClick={join}
        disabled={phase === 'loading'}
        aria-busy={phase === 'loading'}
      >
        {phase === 'loading' ? 'Joining…' : `Join ${name} waitlist`}
      </button>
      {error ? (
        <p className={styles.waitlistError} role="alert">
          {error}
        </p>
      ) : null}
    </>
  );
}
